module.exports = __webpack_public_path__ + "static/media/tuuguu.3bc69566.png";